import { render, staticRenderFns } from "./FormPhones.vue?vue&type=template&id=2393f3c8&"
import script from "./FormPhones.vue?vue&type=script&lang=js&"
export * from "./FormPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports